<template>
    <div
        class="modal bd-example-modal-xl trader-info acc-rej"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content" id="scroll">
            <div class="modal-header">
              <h5 class="modal-title">Curve Yield Change</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body table-responsive">
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Bid Id</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Cusip</th>
                        <th 
                          scope="col" 
                          class="sort text-center"
                        >POINT TO</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >QTY / <br> Min Qty</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >BPS Range <br> Min/Max</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Past Yield <br> Spread</th>
                         <th 
                        scope="col" 
                        class=" text-center"
                        >New Yield <br> Spread</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Past Curve <br> Yield</th>
                         <th 
                        scope="col" 
                        class=" text-center"
                        >New Curve <br> Yield</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >Past <br> Yield</th>
                        <th 
                        scope="col" 
                        class="sort text-center"
                        >New <br> Yield</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Past TMC <br> Price</th>
                         <th 
                        scope="col" 
                        class=" text-center"
                        >New TMC <br> Price</th>
                        <th 
                        scope="col" 
                        class=" text-center"
                        >Action</th>
                    </tr>
                    </thead>  
                    <tbody class="">
                        <tr v-if="bids.length == 0 && !this.loader">
                            <td colspan="14"><p class="nodata n">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="bid in bids" :key="bid.id" v-bind:class="{'cancel-bid-row' : checkBpsRangeExceed(bid.yieldSpread,bid.minBps,bid.maxBps)}">
                            <td class="text-center">{{bid.id}}</td>
                            <td class="text-center">{{bid.cusipVal}}</td>
                            <td class="text-center">
                              <span class="bid text-success">{{bid.pointToDate}} </span>
                              <span class="bid text-primary">{{bid.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}} </span>
                              
                            </td>
                            <td class="text-center">{{bid.quantity}} / {{bid.minQuantity}}</td>
                            <td class="text-center">
                                <span v-if="bid.bidType == 'YIELD'">{{bid.minBps ? bid.minBps : 0}} / {{bid.maxBps ?  bid.maxBps : 0}} </span>
                            </td>
                            <td class="text-center">{{bid.parentYieldSpread}}</td>
                            <td class="text-center">{{bid.yieldSpread}}</td>
                            <td class="text-center">{{bid.parentCurveYield}}</td>
                            <td class="text-center">{{bid.curveYield}}</td>
                            <td class="text-center">
                              {{bid.parentAmount}}
                            </td>
                            <td class="text-center">
                              <div class="tmcamount">
                                <input class="form-control form-control-sm border-danger" type="number" v-model="bid.amount">
                                <div class="position-absolute">%</div>
                              </div>
                            </td>
                            <td class="text-center">
                                {{bid.parentTmcPrice}}
                            </td>
                            <td class="text-center">
                                <input class="form-control form-control-sm border-danger" type="number" v-model="bid.tmcPrice">
                            </td>
                            <td class="text-center"> 
                                <button type="button" @click="updateTmcPrice(bid)" class="btn btn-primary">Update</button>
                            </td>
                        </tr>
                    <div v-if="loader" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    </tbody>
                </table> 
                <!-- Pagination-->
                <b-pagination
                    class="mt-4"
                    :total-rows="totalRows"
                    v-model="currentPage"
                    :per-page="5"
                    @input="getBidList(currentPage)"
                ></b-pagination>
                <div class="total-records">
                    <span>Total Records : {{totalRows}}</span>
                </div>
            </div>
          </div>
        </div>
    </div>      
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
    name: 'TMCPriceUpdatePopup',
    //props: ['bids'],
    data() {
        return {
            bids : [],
            loader : false,
            perPage: 5,
            totalRows : 1,
            currentPage: 1,
            searchValue : "",
            sortColumn: "latestDate",
            sortOrder: "DESC"
        };
    },
    methods : {

    updateTmcPrice(bid){
        var message = "Are you sure you want to update? ";
        if(!parseFloat(bid.tmcPrice) || !parseFloat(bid.amount)){
          this.$alert("Please enter yield and TMC price","","warning");
          return false
        }
        this.$confirm(message).then(() => {
            this.loader = true;
            const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
            .put(
                config.baseUrlBidSide + '/bid/update-bid-price',
                    {
                      "bidId":bid.id,
                      "tmcprice": parseFloat(bid.tmcPrice),
                      "amount":parseFloat(bid.amount)
                    },
                auth
            )
            .then(() => {
                this.loader = false;
                // get index of object with id
                var removeIndex = this.bids.map(function(item) { return item.id; }).indexOf(bid.id);
                // remove object
                this.bids.splice(removeIndex, 1);
            })
            .catch(() => {
                this.loader = false;
            });
        });
        
    },
    getBidList(currentPage) {
      this.loader = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken()  }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/list-waiting?page=" +
            currentPage+
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=WAITING"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
             this.cognitoSub,
            auth

        )
        .then(result => {
          this.loader = false;
          this.totalRows = result.data.pageInfo.totalElements;
          this.bids = result.data.content;  
        })
        .catch(() => {
          this.loader = false;
        });
    },
    checkBpsRangeExceed(BPS,MIN,MAX){
      var bpsValue = parseFloat(BPS.split(" ")[1]) || 0;
      if (bpsValue >= MIN && bpsValue <= MAX) { 
        return false;
      }
      else{
        return true;
      }
    }

  },
  created(){ 
    this.cognitoSub = authService.getUser().cognitoSub;
    this.getBidList(); 
  }
};
</script>